import { render } from "./VisitAttachmentsUploadHC.vue?vue&type=template&id=b47ba616&ts=true"
import script from "./VisitAttachmentsUploadHC.ts?vue&type=script&lang=ts&external"
export * from "./VisitAttachmentsUploadHC.ts?vue&type=script&lang=ts&external"

import "./VisitAttachmentsUploadHC.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__